import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, LaptopIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const plan = {
  name: '📘 LES 100 PRÉCÉDENTS JURIDIQUES AI™',
  ideal: 'Avocats solos, Associés et Juristes qui veulent protéger leur carrière et gagner du temps.',
  was: '165 €',
  now: '27',
  features: ['Système stratégique complet en 6 volumes', '100+ Prompts prêts à l’emploi validés par des experts', 'Compatibilité instantanée avec ChatGPT, Claude, Gemini & DeepSeek', '4 Bonus professionnels gratuits inclus', 'Garantie sans risque de 30 jours', '♾️ Accès à vie & Mises à jour gratuites'],
  cta: 'Obtenir les 100 Précédents Juridiques AI™ maintenant'
};
const trust = [{
  icon: LockIcon,
  label: 'Paiement 100% sécurisé'
}, {
  icon: ZapIcon,
  label: 'Accès instantané'
}, {
  icon: CreditCardIcon,
  label: 'Crédit / Débit'
}, {
  icon: LaptopIcon,
  label: 'Mobile & Tablette'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Tarifs" className="bg-radial-glow w-full scroll-mt-20 overflow-x-hidden" data-id="element-119" data-mp="3vyf7utymt42w">
      <div className="mx-auto w-full max-w-5xl px-5 py-12" style={{
      paddingTop: "15px",
      paddingBottom: "15px"
    }} data-id="element-120" data-mp="4rkqfljmdmzn">
        <div className="mx-auto mb-6 max-w-md text-center" data-id="element-121" data-mp="9qe7tp211y53">
          <p className="font-display text-xl font-black text-plum" data-id="element-122" data-mp="eq0lu0pojiey">🔥 Offre Limitée — Se termine bientôt !</p>
          <p className="mt-2 text-sm font-semibold text-plum/70" data-id="element-123" data-mp="3dail9ql4ral3">
            ⚠️ Après cela, le prix revient à 54 €. Ce tarif ne reviendra pas.
          </p>
          <p className="mt-2 inline-flex rounded-full border border-blush/40 bg-blush-soft px-4 py-1.5 text-xs font-bold text-blush-deep" data-id="element-124" data-mp="3n6ljwmgrwr3a">
            🎟️ Plus que 7 places disponibles à ce prix !
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto flex w-full max-w-md flex-col items-center overflow-hidden rounded-3xl border border-grape/30 bg-white px-6 pb-6 text-center shadow-[0_24px_60px_-28px_rgba(107,16,34,0.5)]" data-id="element-125" data-mp="2uhoe3itr0mrf">
          <div className="-mx-6 mb-5 w-[calc(100%+3rem)] bg-plum px-6 py-3" data-id="element-126" data-mp="2w7bdoz9f7k0m">
            <h3 className="font-display text-base font-black text-white" data-id="element-127" data-mp="28hqtye5g0iqa">{plan.name}</h3>
          </div>
          <p className="text-sm text-plum/60" data-id="element-128" data-mp="23j5tqeq6xz1u">
            <span className="font-semibold text-plum/80" data-id="element-129" data-mp="23kgxiejmz6sy">Idéal pour :</span> {plan.ideal}
          </p>

          <div className="mt-6" data-id="element-130" data-mp="2ihre22b4z2vj">
            <span className="text-[20px] font-medium text-plum/40 line-through" data-id="element-131" data-mp="2dh3f8ugo1hqr">{plan.was}</span>
            <div className="flex w-full justify-center py-2" data-id="element-132" data-mp="3tvbq3rs2q2mk">
              <span className="relative inline-block font-display leading-none" data-id="element-133" data-mp="3ttsam3e8rvlu">
                <span className="text-grape-shine text-[74px] font-black leading-none" style={{
                fontFamily: "Merriweather, serif"
              }} data-id="element-134" data-mp="3ov7b666tdfyg">
                  {plan.now}
                </span>
                <span className="absolute left-full top-1/2 ml-2 -translate-y-1/2 text-[45px] font-black leading-none text-grape" style={{
                fontFamily: "Merriweather, serif"
              }} data-id="element-135" data-mp="5b1jry9mrens">
                  €
                </span>
              </span>
            </div>
            <p className="mt-1 text-xs font-semibold text-grape" data-id="element-136" data-mp="j26dyku8beqq">
              · Paiement unique · Accès à vie ·
            </p>
            <p className="mt-1 text-center text-[11px] font-medium text-plum/55" data-id="element-137" data-mp="o22gsgr6x04p">
              · Le paiement sera effectué dans votre devise locale ·
            </p>
          </div>

          <ul className="mt-6 w-full flex-1 space-y-3 text-left" data-id="element-138" data-mp="e8llf8bencyx">
            {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-plum/80" data-id="element-139" data-mp="11y68o3elcwe0">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-140" data-mp="16rhfw5nbff6g" />
                {f}
              </li>)}
          </ul>

          <div className="mt-7 flex w-full justify-center" data-id="element-141" data-mp="3f55u169ledzd">
            <CTAButton size="md" data-id="element-142" data-mp="3a7nuu7ldnd4k">{plan.cta}</CTAButton>
          </div>

          <p className="mt-3 text-[12px] font-bold text-blush" data-id="element-143" data-mp="358t14alvg45o">
            Économisez 138 € (83% de réduction)
          </p>

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-plum/55" data-id="element-144" data-mp="3192d2enqc24u">
            {trust.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-145" data-mp="3t085sa14exk3">
                <Icon className="h-4 w-4 text-grape" data-id="element-146" data-mp="3o7f11m5njp80" />
                {label}
              </span>)}
          </div>
        </motion.div>

        <div className="mx-auto mt-12 flex w-full max-w-2xl items-start gap-3 rounded-2xl border border-grape/20 bg-white/80 p-5 text-left" data-id="element-147" data-mp="3k6d1133wv94z">
          <ShieldCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-grape" data-id="element-148" data-mp="fsnaehwzx4sq" />
          <p className="text-[15px] leading-relaxed text-plum/75" data-id="element-149" data-mp="fqk9v3y7vt9r">
            <span className="font-display font-bold text-plum" data-id="element-150" data-mp="1yggbav7gmpzm">
              🛡️ Garantie de remboursement de 7 jours.
            </span>{' '}
            Si dans les 7 premiers jours vous estimez que ce système ne vous fait pas gagner au moins 2 heures de rédaction par jour, demandez simplement un remboursement. Nous vous rendrons 100% de votre argent, sans poser de questions. SIGMA SMART™ s'engage à protéger votre pratique.
          </p>
        </div>
      </div>
    </section>;
}